import { createAction } from 'redux-actions';

export const getSeniorFormData = createAction('GET_SENIOR_FORM_DATAS', (slPaymentMerchantId) => (
  { slPaymentMerchantId }
));
export const setSeniorFormData = createAction('SET_SENIOR_FORM_DATAS');

export const setSeniorTimeline = createAction('SET_SENIOR_TIME_LINE');
